import React from "react";
import { Save, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";

export function ProfileTab({ user, profileData, setProfileData, saving, onSave }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Profile Information</CardTitle>
        <CardDescription>Update your personal information and preferences</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center gap-6">
          <div className="w-20 h-20 rounded-full bg-slate-900 dark:bg-cyan-500 flex items-center justify-center text-white dark:text-slate-900 text-2xl font-semibold">
            {user?.name?.charAt(0)?.toUpperCase() || "U"}
          </div>
          <div>
            <p className="font-medium text-lg">{user?.name}</p>
            <p className="text-slate-500 capitalize">{user?.role?.replace("_", " ")}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-500">Full Name</Label>
            <Input value={profileData.name} onChange={(e) => setProfileData({ ...profileData, name: e.target.value })} className="rounded-sm" data-testid="profile-name-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-500">Email Address</Label>
            <Input type="email" value={profileData.email} onChange={(e) => setProfileData({ ...profileData, email: e.target.value })} className="rounded-sm" disabled data-testid="profile-email-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-500">Department</Label>
            <Input value={profileData.department} onChange={(e) => setProfileData({ ...profileData, department: e.target.value })} placeholder="e.g., Legal, Finance" className="rounded-sm" data-testid="profile-department-input" />
          </div>
          <div className="space-y-2">
            <Label className="text-xs font-mono uppercase tracking-wider text-slate-500">Role</Label>
            <Input value={user?.role?.replace("_", " ")} className="rounded-sm capitalize" disabled />
          </div>
        </div>

        <div className="flex justify-end">
          <Button onClick={onSave} disabled={saving} className="gap-2 rounded-sm" data-testid="save-profile-btn">
            {saving ? <Loader2 size={16} className="animate-spin" /> : <Save size={16} />} Save Changes
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
